export default __webpack_public_path__ + "static/media/haiderWaheed.73dee003.png";